<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper reports" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal reports" style="top: 0;">
				<div class="modalContent">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a class="closeWindow clickable" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
							</div>
						</a>
					</div>
					<div>
						<div class="contentHeader unselectable">
							<h2 class="msAntiScroll drag" draggable="true">
								<span>Покинутая долина</span>
							</h2>
						</div>
					</div>
					<div class="heightTransitionContent">
						<div class="contentTabulation">
							<div class="tabulationContent scrollable scrollingDisabled">
								<div class="scrollContentOuterWrapper disableScrolling">
									<div class="scrollContent disableScrolling">
										<div class="scrollContentInnerWrapper">
											<div ng-transclude="">
												<div class="mapCellDetails" ng-controller="mapCellDetailsCtrl">
													<div dynamic="" scrollable="" class="scrollable">
														<div class="scrollContentOuterWrapper" style="width: 610px;">
															<div class="scrollContent" dynamic-height="true" style="width: 610px; overflow-y: hidden; max-height: 453px;">
																<div class="scrollContentInnerWrapper" ng-transclude="" style="width: auto;">
																	<div ng-include="" src="'tpl/mapCellDetails/partials/header.html'">
																		<div class="mapContainer habitable">
																			<!-- ngIf: mapDetails.isWonder -->
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'npcVillageRobber' -->
																			<!-- ngIf: cellData.menhir -->
																			<div class="wrapper" ng-if="fieldType != 'oasis' && fieldType != 'npcVillageRobber' && !mapDetails.isWonder && !cellData.menhir">
																				<div class="background"></div>
																				<div class="foreground resDistribution resources5346"></div>
																			</div>
																			<!-- ngIf: mapDetails.isWonder -->
																			<!-- ngIf: showAttack && attackingTroops.cnt == 0 -->
																			<!-- ngIf: attackingTroops.cnt > 0 -->
																			<!-- ngIf: mapDetails.npcInfo.type == 8 -->
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'oasis' -->
																		</div>
																	</div>
																	<div class="otherContainer habitable">
																		<div ng-include="" src="'tpl/mapCellDetails/partials/bodyTop.html'">
																			<div class="splitContainer habitable">
																				<!-- ngIf: fieldType == 'village' && mapDetails.wwValues -->
																				<!-- ngIf: fieldType == 'village' -->
																				<!-- ngIf: fieldType == 'oasis' -->
																				<!-- ngIf: fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor' -->
																				<!-- ngIf: fieldType == 'unhabitable' -->
																				<div ng-if="fieldType == 'habitable'">
																					<div class="contentBox">
																						<div class="contentBoxHeader headerColored">
																							<h6>
																								<span ng-if="!cellData.menhir" translate=""><span>Основать деревню</span></span>
																								<!-- ngIf: cellData.menhir -->
																								<span>
																									<span class="coordinateWrapper" coordinates="" x="-51" y="-4">
																										<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536756173_1708113954');" class="clickable">
																											<span class="coordinates coordinatesWrapper " ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(-51</span><span class="coordinatePipe">|</span><span class="coordinateY">-4)</span></span>
																										</a>
																										<!-- ngIf: !hasLink -->
																									</span>
																								</span>
																							</h6>
																						</div>
																						<div class="contentBoxBody scrollable" scrollable="">
																							<div class="scrollContentOuterWrapper" style="width: 289px;">
																								<div class="scrollContent" dynamic-height="false" style="width: 289px; overflow-y: hidden;">
																									<div class="scrollContentInnerWrapper" ng-transclude="" style="width: auto;">
																										<div ng-if="!cellData.menhir" class="description" translate=""><span>Ты можешь поселиться здесь. Для этого тебе нужны три поселенца, свободный слот экспансии и достаточно единиц культуры.</span></div>
																										<!-- ngIf: cellData.menhir -->
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																					<div class="contentBox">
																						<div ng-include="" src="'tpl/mapCellDetails/partials/landDistribution.html'">
																							<div class="villageDetails contentBoxHeader headerColored">
																								<h6 translate=""><span>Распределение</span></h6>
																							</div>
																							<div class="contentBoxBody">
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_wood_large_illu"></i>
																									<span>5</span>
																								</div>
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_clay_large_illu"></i>
																									<span>3</span>
																								</div>
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_iron_large_illu"></i>
																									<span>4</span>
																								</div>
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_crop_large_illu"></i>
																									<span>6</span>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div ng-include="" src="'tpl/mapCellDetails/partials/bodyBottom.html'">
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'village' && mapDetails.isWonder && !mapDetails.isConquered -->
																			<div class="tributeCropContainer">
																				<div class="tributes contentBox gradient ng-hide" ng-show="showTributes">
																					<div class="contentBoxBody">
																						<display-resources resources="village.tributes" treasures="village.tributeTreasures" hide-zero="true">
																							<div class="costs max0digits">
																								<span ng-if="!checkStorage">
																									<!-- ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes -->
																								</span>
																								<!-- ngIf: checkStorage -->
																								<!-- ngIf: (consumption || consumption == 0) && consumption != 'false' -->
																								<!-- ngIf: population || population == 0 -->
																								<!-- ngIf: treasures || treasures == 0 -->
																								<!-- ngIf: stolenGoods || stolenGoods == 0 -->
																								<!-- ngIf: time || time == 0 -->
																								<!-- ngIf: enoughResSecs == -1 -->
																								<!-- ngIf: enoughResSecs > 0 -->
																								<!-- ngIf: capacityHint -->
																								<div class="iconButton premium npcTrade ng-hide" ng-show="showNpc != undefined"><i class="feature_npcTrader_small_flat_black"></i></div>
																							</div>
																						</display-resources>
																						<div class="barView">
																							<div class="actualTributes">0/0</div>
																							<div class="populationBar progressbar" progressbar="" type="green" perc="" marker="">
																								<!-- ngIf: ::labelIcon -->
																								<div class="progress">
																									<!-- ngIf: steps -->
																									<div class="bar positive perc green" style="z-index: -1; width: 0%;"></div>
																									<div class="bar additionalBar additionalPerc"></div>
																									<div class="marker" style="z-index: -1; width: 0%;">
																										<div class="markerInner"></div>
																									</div>
																									<!-- ngIf: ::showCountdown -->
																									<!-- ngIf: ::label -->
																									<!-- ngIf: ::percTooltip -->
																								</div>
																							</div>
																						</div>
																						<button clickable="fetchTributes()" ng-class="{disabled: !village.canFetchTributes || !village.allowTributeCollection || !village.protectionGranted || !activeTreasury || (!territoryConnected && village.type != Village.TYPE_GOVERNOR_NPC_VILLAGE)}" play-on-click="16" tooltip="" tooltip-translate-switch="{
																							'ContextMenu.button.fetchTribute.denied': true,
																							'ContextMenu.button.fetchTribute.unprotected': true,
																							'Tributes.VillageNotGeneratingInfluence': true,
																							'Tributes.VillageNotConnected': false
																						}" class="clickable disabled">
																							<div class="content">
																								<span ng-transclude="" class="innerText">
																									<span translate=""><span>Собрать дань</span></span>
																								</span>
																								<!-- ngIf: price > 0 || forceGoldUsage -->
																								<!-- ngIf: price == -1 && !forceGoldUsage -->
																								<div class="animationOverlay"></div>
																								<i class="checkmark action_check_small_flat_white"></i>
																								<i class="checkmark action_check_small_flat_black"></i>
																								<i class="checkmark action_check_small_flat_red"></i>
																							</div>
																						</button>
																					</div>
																				</div>
																				<!-- ngIf: sharedInformations.cropDetails != null -->
																			</div>
																			<p ng-show="error" class="error ng-hide"></p>
																			<!-- ngIf: fieldType == 'village' || fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor' -->
																			<!-- ngIf: sharedInformations.stationedTroops.length > 0 -->
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="cellActionContainer">
														<div class="iconButton centerMapButton clickable" content="Центрировать" v-tippy="{placement: 'top'}" tooltip-translate="CellDetails.CenterMap" clickable="openPage('map', 'centerId', '536756173_1708113954'); closeWindow(w.name);">
															<i class="symbol_target_small_flat_black"></i>
														</div>
														<div class="options" ng-if="options.length > 0" more-dropdown="" more-dropdown-options="getOptions()" style="position: relative;">
															<a class="iconButton clickable" clickable="openMoreDropdown()">
																<!-- ngIf: showCount -->
																	<i class="symbol_arrowDown_tiny_illu"></i>
															</a>
															<div class="moreDropDownBody dropdownBody" style="bottom: 0; right: 0; display: block;">
																<ul>
																	<li ng-repeat="option in options" clickable="openWindow('markerMenu',{'cellId': 536756173}); closeMoreDropdown()" class="clickable">Отметить поле</li>
																</ul>
															</div>
														</div>
														<!-- ngIf: fieldType == 'village' || fieldType == 'oasis' || fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor' -->
														<button class="sendTroopsButton clickable disabled" content="Чтобы основать деревню, нужны 3 поселенца. Их можно обучить во дворце или резиденции." v-tippy="{placement: 'top'}" ng-if="fieldType == 'habitable' && !cellData.menhir" ng-class="{disabled: !enoughSettlers || !hasRallyPoint}" clickable="settleHere()">
															<div class="content">
																<span ng-transclude="" class="innerText">
																	<span translate=""><span>Основание поселения</span></span>
																</span>
																<!-- ngIf: price > 0 || forceGoldUsage -->
																<!-- ngIf: price == -1 && !forceGoldUsage -->
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
														<!-- ngIf: cellData.menhir && cellData.menhir == player.data.playerId -->
														<!-- ngIf: cellData.menhir && cellData.owner == player.data.playerId -->
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>